import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import { toast } from "react-toastify";
import AuthContext from "../context/AuthContext";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import Layout from "./Layout";
import jwtDecode from "jwt-decode";
import { Controller } from "react-hook-form";
const BANNER_URL =
  "/assets/images/en-desktop-6a9d88ea8eadd.webp";

const COUNTRY_CODE = "880"; // matches the fixed +880 select shown in the new design

const generateCaptchaText = () =>
  Math.random().toString(36).substring(2, 8).toUpperCase();

const drawCaptcha = (canvas, text) => {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#f2f2f2";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.font = "bold 20px sans-serif";
  ctx.fillStyle = "#333";
  ctx.textBaseline = "middle";
  [...text].forEach((ch, i) => {
    ctx.save();
    ctx.translate(10 + i * 10, canvas.height / 2 + (Math.random() * 6 - 3));
    ctx.rotate((Math.random() * 20 - 10) * (Math.PI / 180));
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });
};

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const captchaRef = useRef(generateCaptchaText());
  const [captchaVersion, setCaptchaVersion] = useState(0);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm();

  React.useEffect(() => {
    drawCaptcha(canvasRef.current, captchaRef.current);
  }, [captchaVersion]);

  const refreshCaptcha = () => {
    captchaRef.current = generateCaptchaText();
    setValue("captcha", "");
    setCaptchaVersion((v) => v + 1);
  };

  const onSubmit = async (body) => {
    localStorage.clear();
    try {
      const { status, data: response_users1 } = await apiPost(
        apiPath.registerUser,
        {
          username: body?.username,
          password: body?.password,
          uniqueId: Math.random() * 10000,
          phone_number: `+${COUNTRY_CODE}${body?.mobile}`,
          // email: body?.email,
        },
      );
      if (status === 200) {
        if (response_users1.success) {
          localStorage.setItem("token", response_users1?.results?.token);
          localStorage.setItem(
            "refresh_token",
            response_users1?.results?.refresh_token,
          );
          setUser(jwtDecode(response_users1?.results.token));
          navigate("/");
          window.location.reload();
        } else {
          toast.error(response_users1?.message);
        }
      } else {
        toast.error(response_users1?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const isTermsChecked = watch("terms");
  return (
    <Layout>
      <div className="row register_panel no-gutters">
        <div className="row register_wrapper no-gutters px-5 py-5">
          <div className="no-gutters col">
            <div className="v-window v-item-group theme--light">
              <div className="v-window__container">
                <div className="v-window-item">
                  <form
                    noValidate="novalidate"
                    className="v-form"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="v-card__text ma-0 pa-0">
                      {/* Username */}
                      <div className="mobile">
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className="input-field-label ma-0 text-capitalize d-block"
                              style={{ float: "left" }}
                            >
                              {t("Username")}<span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-12">
                            <div
                              className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined ${
                                errors?.username ? "error--text" : ""
                              }`}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      autoComplete="new-password"
                                      type="text"
                                      {...register("username", {
                                        minLength: {
                                          value: 3,
                                          message: t("Min3User"),
                                        },
                                        maxLength: {
                                          value: 30,
                                          message: t("Max30User"),
                                        },
                                        pattern: {
                                          value: /^[a-zA-Z ]*$/,
                                          message: t("Enter_Valid_Username"),
                                        },
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="v-text-field__details">
                                  <div
                                    className="v-messages theme--light error--text"
                                    role="alert"
                                  >
                                    <div className="v-messages__wrapper">
                                      {errors?.username && (
                                        <div className="v-messages__message">
                                          {errors.username.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Password */}
                      <div className="mobile">
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className="input-field-label ma-0 text-capitalize d-block"
                              style={{ float: "left" }}
                            >
                              {t("Password")}<span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-12">
                            <div
                              className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined ${
                                errors?.password ? "error--text" : ""
                              }`}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      autoComplete="new-password"
                                      type="password"
                                      {...register("password", {
                                        required: t("Enter_Password"),
                                        minLength: {
                                          value: 6,
                                          message: t("PasswordMin"),
                                        },
                                        maxLength: {
                                          value: 20,
                                          message: t("PasswordMax"),
                                        },
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="v-text-field__details">
                                  <div
                                    className="v-messages theme--light error--text"
                                    role="alert"
                                  >
                                    <div className="v-messages__wrapper">
                                      {errors?.password && (
                                        <div className="v-messages__message">
                                          {errors.password.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Confirm Password */}
                      <div className="mobile">
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className="input-field-label ma-0 text-capitalize d-block"
                              style={{ float: "left" }}
                            >
                              {t("Confirm_Password")}
                              <span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-12">
                            <div
                              className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined ${
                                errors?.confirmpassword ? "error--text" : ""
                              }`}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      autoComplete="new-password"
                                      type="password"
                                      {...register("confirmpassword", {
                                        required: t("Enter_CPassword"),
                                        validate: (value) =>
                                          value === watch("password") ||
                                          t("PasswordMatch"),
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="v-text-field__details">
                                  <div
                                    className="v-messages theme--light error--text"
                                    role="alert"
                                  >
                                    <div className="v-messages__wrapper">
                                      {errors?.confirmpassword && (
                                        <div className="v-messages__message">
                                          {errors.confirmpassword.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="v-form">
                      
                      {/* <div className="mobile">
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className="input-field-label ma-0 text-capitalize d-block"
                              style={{ float: "left" }}
                            >
                              {t("VerificationCode")}
                              <span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-8">
                            <div
                              className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined ${
                                errors?.captcha ? "error--text" : ""
                              }`}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      autoComplete="off"
                                      type="text"
                                      {...register("captcha", {
                                        required: t("MandatoryField"),
                                        validate: (value) =>
                                          value?.toUpperCase() ===
                                            captchaRef.current ||
                                          t("VerificationCodeMismatch"),
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="v-text-field__details">
                                  <div
                                    className="v-messages theme--light error--text"
                                    role="alert"
                                  >
                                    <div className="v-messages__wrapper">
                                      {errors?.captcha && (
                                        <div className="v-messages__message">
                                          {errors.captcha.message}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="captcha-code col col-4">
                            <div className="captcha-code-wrapper captcha">
                              <canvas
                                ref={canvasRef}
                                width={72}
                                height={40}
                                className="captcha-canvas"
                              />
                            </div>
                            <a className="refresh" onClick={refreshCaptcha}>
                              <i
                                aria-hidden="true"
                                className="v-icon notranslate mdi mdi-refresh theme--light"
                              />
                            </a>
                          </div>
                        </div>
                      </div> */}

                      {/* Phone Number */}
                      <div className="v-card__text ma-0 pa-0">
                        <label className="input-field-label ma-0 pb-2 text-capitalize d-block">
                          {t("PhoneNumber")}
                          <span className="red--text ml-1">*</span>
                        </label>
                        <div className="row no-gutters">
                          <div className="col col-5">
                            <div className="v-input input-field mr-2 black--text v-input--is-readonly v-input--dense theme--light v-text-field v-text-field--enclosed v-text-field--outlined v-select">
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-select__slot">
                                    <div className="v-select__selections">
                                      <div className="v-select__selection v-select__selection--comma">
                                        +{COUNTRY_CODE}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col col-7">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined ${
                                      errors?.mobile ? "error--text" : ""
                                    }`}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            type="text"
                                            {...register("mobile", {
                                              required: t("Enter_Mobile"),
                                              validate: (value) => {
                                                const digits =
                                                  value?.toString() || "";
                                                if (digits.length < 10) {
                                                  return t("MobileMin");
                                                }
                                                if (digits.length > 12) {
                                                  return t("MobileMax");
                                                }
                                                return true;
                                              },
                                            })}
                                          />
                                        </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div
                                          className="v-messages theme--light error--text"
                                          role="alert"
                                        >
                                          <div className="v-messages__wrapper">
                                            {errors?.mobile && (
                                              <div className="v-messages__message">
                                                {errors.mobile.message}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="v-form">
                      <div className="v-card__text ma-0 pa-0">
                        {/* Email */}
                        {/* <div className="row no-gutters">
                          <div className="col col-12">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block"
                                    style={{ float: "left" }}
                                  >
                                    {t("Email")}
                                  </label>
                                </div>
                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                      errors?.email ? "error--text" : ""
                                    }`}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            type="text"
                                            placeholder={t("FillUpHere")}
                                            {...register("email", {
                                              required: t("Pleaseenteremail"),
                                              pattern: {
                                                value:
                                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: t("Invalidemailaddress"),
                                              },
                                            })}
                                          />
                                        </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div
                                          className="v-messages theme--light error--text"
                                          role="alert"
                                        >
                                          <div className="v-messages__wrapper">
                                            {errors?.email && (
                                              <div className="v-messages__message">
                                                {errors.email.message}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        {/* Referral Code */}
                        <div className="row no-gutters">
                          <div className="col col-12">
                            <div className="mobile">
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block"
                                    style={{ float: "left" }}
                                  >
                                    {t("ReferCode")}
                                  </label>
                                </div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--enclosed v-text-field--outlined">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            type="text"
                                            {...register("refreralCode")}
                                          />
                                        </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div className="v-messages theme--light">
                                          <div className="v-messages__wrapper" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Terms checkbox */}
                        <div className="row no-gutters">
                          <div className="col col-12">
                            <Controller
                              control={control}
                              name="terms"
                              rules={{
                                required: t("AgreeTermsRequired"),
                              }}
                              defaultValue={false}
                              render={({ field: { value, onChange } }) => (
                                <div
                                  className={`v-input mt-0 pt-0 theme--light v-input--selection-controls v-input--checkbox ${
                                    value
                                      ? "v-input--is-label-active v-input--is-dirty primary--text"
                                      : ""
                                  }`}
                                >
                                  <div className="v-input__control">
                                    <div className="v-input__slot">
                                      <div
                                        className="v-input--selection-controls__input"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => onChange(!value)}
                                      >
                                        <i
                                          aria-hidden="true"
                                          style={{ pointerEvents: "none" }}
                                          className={`v-icon notranslate theme--light ${
                                            value
                                              ? "mdi mdi-checkbox-marked primary--text"
                                              : "mdi mdi-checkbox-blank-outline"
                                          }`}
                                        />
                                        <input
                                          id="terms"
                                          role="checkbox"
                                          type="checkbox"
                                          checked={!!value}
                                          onChange={(e) =>
                                            onChange(e.target.checked)
                                          }
                                          style={{ pointerEvents: "none" }}
                                          tabIndex={-1}
                                        />
                                        <div
                                          className={`v-input--selection-controls__ripple ${
                                            value ? "primary--text" : ""
                                          }`}
                                          style={{ pointerEvents: "none" }}
                                        />
                                      </div>
                                      <label
                                        htmlFor="terms"
                                        className="v-label theme--light"
                                        style={{
                                          left: "0px",
                                          right: "auto",
                                          position: "relative",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => onChange(!value)}
                                      >
                                        <p className="caption pt-2 mb-0">
                                          <label>
                                            {t("IAGREE")}{" "}
                                          </label>
                                          <label
                                            className="secondary--text font-weight-bold"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {t("TC")}
                                          </label>
                                        </p>
                                      </label>
                                    </div>
                                    <div
                                      className={`v-messages theme--light ${
                                        errors?.terms
                                          ? "error--text"
                                          : value
                                            ? "primary--text"
                                            : ""
                                      }`}
                                    >
                                      <div className="v-messages__wrapper">
                                        {errors?.terms && (
                                          <div className="v-messages__message">
                                            {errors.terms.message}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          </div>
                        </div>

                        <div className="row d-flex justify-center align-center no-gutters">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="circle-button text-capitalize ml-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                            style={{ backgroundColor: "rgb(20, 37, 144)" }}
                          >
                            <span className="v-btn__content">
                              {isSubmitting ? t("PleaseWait") : t("Complete")}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop registration banner */}
          <div className="no-gutters col-md-8 col-12">
            <div
              className="v-window v-item-group theme--dark v-carousel"
              style={{ height: "auto" }}
            >
              <div className="v-window__container" style={{ height: "auto" }}>
                <div className="v-window-item" style={{ display: "grid" }}>
                  <div
                    className="v-image v-responsive v-carousel__item theme--light"
                    style={{ height: "auto" }}
                  >
                    <div className="v-responsive__content">
                      <div className="v-image v-responsive theme--light">
                        <div
                          className="v-responsive__sizer"
                          style={{ paddingBottom: "72.8723%" }}
                        />
                        <div
                          className="v-image__image v-image__image--contain"
                          style={{
                            backgroundImage: `url("${BANNER_URL}")`,
                            backgroundPosition: "center center",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
